import React from "react";
import LeftAbout from "./LeftAbout";
import RightAbout from "./RightAbout";

const About = () => {
  return (
    <section
      id="about"
      className="w-full pt-10 pb-0 flex flex-col gap-10 mdl:gap-0 xl:flex-row items-center border-b-[1px] border-b-black font-titleFont"
    >
      <LeftAbout></LeftAbout>
      <RightAbout></RightAbout>
    </section>
  );
};

export default About;
